// extracted by mini-css-extract-plugin
export var dropdown = "_f4-0";
export var imagePlaceholder = "_f4-2";
export var imageWrapper = "_f4-3";
export var productImage = "_f4-1";
export var truncateContainer = "_f4-4";
export var truncateText = "_f4-5";